import { GET_TAGS } from 'actions/Types';

export const getAllTags = () => {
  return dispatch => {
    const action = {
      type: GET_TAGS,
      request: async apiClient => {
        const tags = await apiClient.tag.getAll();

        return tags;
      }
    };

    dispatch(action);
  };
};
